export const iconFontAwesomeDesignClone = (
	<i className="fa-solid fa-clone"></i>
);
